import { render, staticRenderFns } from "./teacher_details.vue?vue&type=template&id=5869c836&scoped=true&"
import script from "./teacher_details.vue?vue&type=script&lang=js&"
export * from "./teacher_details.vue?vue&type=script&lang=js&"
import style0 from "./teacher_details.css?vue&type=style&index=0&id=5869c836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5869c836",
  null
  
)

export default component.exports